import script from "./SettlementMockBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementMockBadge.vue?vue&type=script&setup=true&lang=js"

import "./SettlementMockBadge.vue?vue&type=style&index=0&id=4f221f14&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f221f14"]])

export default __exports__